import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@apollo/client';
import useIsBrowser from 'hooks/useIsBrowser';
import isNewConsumerApp from 'commons/isNewConsumerApp';
import { GET_FABRIC_REVIEWS } from '../../mocks/queries';
const useFabricReviews = fabricId => {
  const $ = _c(14);
  const isBrowser = useIsBrowser();
  let t0;
  if ($[0] !== fabricId) {
    t0 = fabricId?.toString();
    $[0] = fabricId;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = {
      fabricValueId: t0
    };
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const t2 = isNewConsumerApp && !isBrowser || !fabricId;
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = {
      variables: t1,
      skip: t2
    };
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const {
    loading,
    error,
    data
  } = useQuery(GET_FABRIC_REVIEWS, t3);
  const t4 = data?.getFabricReviews?.rating;
  const t5 = data?.getFabricReviews?.reviews;
  let t6;
  if ($[7] !== t4 || $[8] !== t5) {
    t6 = {
      rating: t4,
      reviews: t5
    };
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== error || $[11] !== loading || $[12] !== t6) {
    t7 = {
      loading,
      error,
      data: t6
    };
    $[10] = error;
    $[11] = loading;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
};
export default useFabricReviews;